/* global _, DocViewerBridge, DocViewerEvents */
var Utils = require('@amzn/aws-workdocs-web-client-common').Utils;


(function(angular, _) {
    'use strict';

    angular.module('GorillaBoy.DocumentViewer')
    .controller('DocumentController', [
        '$scope',
        '$http',
        '$window',
        '$routeParams',
        '$filter',
        '$log',
        '$timeout',
        '$location',
        '$q',
        '$sce',
        '$rootScope',
        '$document',
        '$translate',
        '$uibModal',
        'ContentTypeFormatter',
        'Document',
        'DocumentStateService',
        'SignalProvider',
        'OrganizationService',
        'DocumentService',
        'GetNextDocumentService',
        'ResourceService',
        'GroupService',
        'RightsUtil',
        'PreferencesService',
        'SessionManager',
        'LayoutManager',
        'FileManagerFactory',
        'FileService',
        'DateFormatter',
        'MessageManager',
        'MessageProvider',
        'Anonymous',
        'FileCountService',
        'focus',
        'SourceConstant',
        'DocumentUtilities',
        'AppConstants',
        'TranslateFactory',
        'FeatureManagerService',
        'Features',
        'userInfo',
        'ClientMetricsService',
        'MetricEvents',
        'DateTimeService',
        'AnnotationService',
        'UIEvents',
        'CheckinCheckoutController',
        'CompanionService',
        'UserCollectionService',
        'UserService',
        'FeedbackService',
        'OfficeEditorController',
        'BrowserService',
        'DocumentModalsController',
        'DocumentSourceUrlController',
        'EndpointService',
        'PathManager',
        'localStorageService',
        'RegionService',
        'EndpointConfig',
        'NativeRenderingUtils',
        'AuthService',
        'TokenService',
        'FeedbackSyncService',
        'TasksService',
        'ShareLinkService',
        DocumentController
    ]);

    function DocumentController($scope,
        $window,
        $http,
        $routeParams,
        $filter,
        $log,
        $timeout,
        $location,
        $q,
        $sce,
        $rootScope,
        $document,
        $translate,
        $uibModal,
        ContentTypeFormatter,
        Document,
        DocumentStateService,
        SignalProvider,
        OrganizationService,
        DocumentService,
        GetNextDocumentService,
        ResourceService,
        GroupService,
        RightsUtil,
        PreferencesService,
        SessionManager,
        LayoutManager,
        FileManagerFactory,
        FileService,
        DateFormatter,
        MessageManager,
        MessageProvider,
        Anonymous,
        FileCountService,
        focus,
        SourceConstant,
        DocumentUtilities,
        AppConstants,
        TranslateFactory,
        FeatureManagerService,
        Features,
        userInfo,
        ClientMetricsService,
        MetricEvents,
        DateTimeService,
        AnnotationService,
        UIEvents,
        CheckinCheckoutController,
        CompanionService,
        UserCollectionService,
        UserService,
        FeedbackService,
        OfficeEditorController,
        BrowserService,
        DocumentModalsController,
        DocumentSourceUrlController,
        EndpointService,
        PathManager,
        localStorageService,
        RegionService,
        EndpointConfig,
        NativeRenderingUtils,
        AuthService,
        TokenService,
        FeedbackSyncService,
        TasksService,
        ShareLinkService) {
        var UNAUTHORIZED_RESOURCE_ACCESS_EXCEPTION = 'UnauthorizedResourceAccessException',
            ANNOTATION_COLORS = ['#0e72a3', '#9c305a', '#4e813a', '#ff8f00', '#008187', '#675dc6', '#dd5c27', '#bf1e0f', '#8fba75', '#8ea9c9', '#825f87', '#ffba20', '#787984'],
            ALLOWED = 'ALLOWED',
            DISALLOWED = 'DISALLOWED',
            // AppConstant bindings
            collaboratorTypes = AppConstants.CollaboratorTypes,
            globalRoles = AppConstants.GlobalRoles,
            viewTypes = AppConstants.ViewTypes,
            rightTabTypes = AppConstants.RightTabTypes,
            documentStatus = AppConstants.DocumentStatus,
            permissions = AppConstants.Permissions,
            layoutViewTypes = AppConstants.LayoutViewTypes,
            skuTypes = AppConstants.SkuType,
            sharedLinkScope = AppConstants.SharedLinkScope,

            // SECTION: Constants for expanding groups
            groupUserMarker = null,
            usersInGroup = [],
            NUM_GROUP_USERS_SHOWN = 8,

            defaultSidebar = {
                selectedIndex: 0,
                tabName: rightTabTypes.PEOPLE_TAB,
                tabs: [rightTabTypes.PEOPLE_TAB]
            };

        // Time at which last GetDocument call has been made
        var getDocumentCallTimestamp = new Date(),
            documentControllerStartTimeStamp = null,
            documentControllerLoadEvent = null,
            feedbackFetchingLatency = null;


        $scope.documentFormData = {
            accessRequestText : ''
        };

        $scope.isAnonymousSharingEnabled = FeatureManagerService.isFeatureEnabled(Features.UI.ANONYMOUS_LINK);
        $scope.isVersionDeleteEnabled = FeatureManagerService.isFeatureEnabled(Features.UI.VERSION_DELETE);

        DocumentModalsController.initScope($scope);
        CheckinCheckoutController.initScope($scope, userInfo);
        DocumentSourceUrlController.initScope($scope);

        /**
         * Use this method to add flags to the view model ($scope.documentState) to show FRE (First Run Experience)
         */
        $scope.processFirstRunExp = function() {
            var filterPanelToolTipShown = localStorageService.get(AppConstants.FRE_LOCAL_STORAGE.FEEDBACK_FILTER);
            if (!filterPanelToolTipShown) {
                localStorageService.set(AppConstants.FRE_LOCAL_STORAGE.FEEDBACK_FILTER, true);
                //By setting this flag and using it in the popover-is-open, it will show on document load
                //but will be reset when user hovers over that icon, which is the desired behaviour
                $scope.documentState.firstRunFilterPanelTooltipShow = true;
            }
        };


        $scope.showFeedbackButton = function() {
            var hasPermissionToViewFeedbacks = !!DocumentStateService.currentUserRoles && DocumentStateService.currentUserRoles.some(function(role) {
                return role.role === AppConstants.GlobalRoles.OWNER ||
                    role.role === AppConstants.GlobalRoles.COOWNER ||
                    role.role === AppConstants.GlobalRoles.CONTRIBUTOR;
            });
            var isFileRecycled = $scope.isFileRecycled();
            var isFeedbackDisplayed = $scope.sidebar.tabName === AppConstants.RightTabTypes.FEEDBACK_TAB;
            return $scope.layout.hasRightSidebar && !isFeedbackDisplayed && hasPermissionToViewFeedbacks && !isFileRecycled;
        };

        /**
         * @ngdoc method
         * @name togglePreventDownload
         *
         * @description
         * Toggle whether the document can be downloaded.
         */
        $scope.togglePreventDownload = function () {
            // The new allow upload and download permission on the document is negation of the current permission.
            var newAllowDownloadPermission = !$scope.documentState.disallowDownload;
            DocumentService.updateDocumentPermissions($scope.documentState.documentId, newAllowDownloadPermission)
            .then(function (data) {
                if (!!newAllowDownloadPermission) {
                    MessageManager.addSuccessMessage(MessageProvider.preventDownloadDisableSuccess);
                } else {
                    MessageManager.addSuccessMessage(MessageProvider.preventDownloadEnableSuccess);
                }
            }, function (data){
                MessageManager.addErrorMessage(MessageProvider.preventDownloadFailure);
            });
        };

        $scope.disableFeedbackChanged = function() {
            $scope.metadata.CommentsLocked = "" + $scope.documentFormData.disableFeedback;
            if ($scope.metadata.DocumentCategory === AppConstants.DocumentTypes.NOTE) {
            	$scope.documentFormData.disableFeedback = true;
            	$scope.documentFormData.disableFilter = true;
            	$scope.metadata.CommentsLocked = "" + $scope.documentFormData.disableFeedback;
            	MessageManager.addTransientErrorMessage(MessageProvider.documentFeedbackDisabledForNote);
            } else {
            	FeedbackService.disableFeedbackForDocument($scope.metadata.Id, $scope.documentFormData.disableFeedback)
                .then(function() {
                    var langKey = $scope.documentFormData.disableFeedback ? 'MESSAGES.DOCUMENT_DISABLE_FEEDBACK_SUCCESS' : 'MESSAGES.DOCUMENT_ENABLE_FEEDBACK_SUCCESS';
                    MessageManager.addSuccessMessage($translate.instant(langKey));
                }, function disableFeedbackChangedFailure() {
                    $scope.documentFormData.disableFeedback = !$scope.documentFormData.disableFeedback;
                    $scope.metadata.CommentsLocked = "" + $scope.documentFormData.disableFeedback;
                    MessageManager.addTransientErrorMessage(MessageProvider.documentDisableFeedbackFailure);
                });
            }
            $scope.deselectFeedback();
        };
        $scope.deselectFeedback = function() {
            DocumentStateService.feedback.selectedFeedback = null;
            $scope.documentState.documentViewerBridge.annotationDeselected();
        };

        function successRequestAccess(response) {
            $uibModal.open({
                templateUrl: 'accessRequestSuccessMessage.html'
            });
            $scope.userRequestedForThisDocAlready = true;
            $scope.documentState.showRequestAccessInputComponent = false;
            DocumentService.setResourceAsRequested($routeParams.documentId);
        }

        function errorRequestAccess(response) {
            $uibModal.open({
                templateUrl: 'accessRequestErrorMessage.html'
            });
        }

        $scope.submitAccessRequest = function() {
            if ($scope.userRequestedForThisDocAlready) {
                return;
            }

            if (FeatureManagerService.isFeatureEnabled(Features.UI.SHOW_TASKS)) {
                TasksService.createTask(null, null, $routeParams.documentId, AppConstants.TASKDEF_IDS.REQUEST_ACCESS)
                .then(successRequestAccess, errorRequestAccess);
            }  else {
                DocumentService.submitAccessRequest($routeParams.documentId, $scope.documentFormData.accessRequestText)
                .then(successRequestAccess, errorRequestAccess);
            }
        };
        $scope.userRequestedForThisDocAlready = DocumentService.didUserRequestForThisResourceAlready($routeParams.documentId);
        // Verify there isn't an existing task to request access
        if(!$scope.userRequestedForThisDocAlready && FeatureManagerService.isFeatureEnabled(Features.UI.SHOW_TASKS)) {
            TasksService.getTasks($routeParams.documentId, null, null, null)
            .then(function(response){
                $scope.userRequestedForThisDocAlready = (response.Tasks.length > 0);
            }, function(response){
                $log.error(response);
            });
        }

        function initializeDocumentViewTimeEvent() {
            documentControllerStartTimeStamp = Date.now();
            ClientMetricsService.startLatencyEvent(MetricEvents.DOCUMENT_REQUEST_START);
            documentControllerLoadEvent = MetricEvents.DOCUMENT_VIEW_EVENT;
            $log.debug("Initializing document view time event, start timestamp: " + documentControllerStartTimeStamp);
            documentControllerLoadEvent.startRoutePath = window.location.hash;
        }

        activate();

        /**
         * Main function that gets invoked when this controller is activated.
         */
        function activate() {
            $log.debug(new Date().toISOString() + ' [DocumentController] Initiating…');

            if(Document.data && DocumentUtilities.isQuartzDocument(Document.data.Metadata)) {
              $location.path('/quartz/' + $routeParams.documentId).replace();
            }

            $rootScope.preFetchSharedWithMeDebounced();
            DocumentStateService.resetDocumentState();

            // Initialize the metric events valid for this controller
            initializeDocumentViewTimeEvent();

            // Initialize the document loaded time for integration tests
            $rootScope.pdfLoadedTime = null;

            if (!Anonymous) {
                FileManagerFactory.setUserContext(userInfo);
            }

            // Used for assigning colors to users. Start at 1
            DocumentStateService.usersToAnnotationsCount = 1;
            DocumentStateService.feedbackMetadata = {};

            var isOfficeEditMode = $routeParams.officeEditor && $rootScope.office365EditingEnabled;

            // SECTION: Layout code
            $scope.layout = {
                resizableRightSidebar : true,
                partialContent: './document-viewer/content_partial.html',
                partialModals: './document-viewer/modals.html',
                partialTitleBar: './document-viewer/title_bar.html',
                partialSidebarPeople: './document-viewer/sidebar_people.html',
                partialSidebarFeedbackInput: './document-viewer/feedback_input.html',
                view: layoutViewTypes.VIEW_DOCUMENT_LAYOUT,
                inOfficeEditorView :  (typeof isOfficeEditMode !=='undefined') ? isOfficeEditMode : false,
                //Master copy of whether left sidebar should be shown/hidden.
                showLeftSidebar: $rootScope.showLeftSidebar,
                hasRightSidebar: true,
                showRightSidebar: true,
                showUploadPane: false,
                showFilterPanel: false,
                isAnonymous: Anonymous,
                showRightTabCompleted: null
            };

            // SECTION: Document Controller State variables
            $scope.documentState = {
                totalVersionsSize: 0,
                commentFilterPreferenceMap : angular.copy(AppConstants.FEEDBACK_FILTER_INTIAL_STATE),
                userToFeedbackCountMap : {},
                feedbackLoaded : false,
                feedbackLoadingPromise: null,
                feedbackListMap : {},
                partialFeedbackLoaded : false,
                documentVersionCommentsMap : {},
                officeEditorMode : isOfficeEditMode,
                //We'll use the below flags for storing the overall and draft publishing comment texts
                overallCommentText : '',
                draftPublishingText : '',
                otherFeedbackText : {},     // Map of strings keyed by annotationID.
                checkinCheckoutEnabled : FeatureManagerService.isFeatureEnabled(Features.UI.CHECKIN_CHECKOUT),
                searchParamFeedbackHighlighted : false,
                sharingDialogShownForRequestAccess : false,
                expandCollapsedState : {},
                documentId: $routeParams.documentId,
                currentOwnerUsername: null,
                documentErrorCode: 0,
                selectionPage: 0,
                documentVersions: [],
                timer: null, // promise used to grab underlays for the active version
                activeVersionId: '',
                activeVersionIndex: 1,
                documentVersionDownloadUrl: '',
                pdfUnderlayShown: false,

                // Related to permissions
                disallowDownload: false, // Now used only as the ViewModel for enabling/disabliing "download" for others

                // Related to permissions V2
                principals: null,
                feedbackRequestInfo: {},

                // Related to loading pdf and text (annotation index)
                pdfDataLoaded: false,

                // Related to status of creating feedback
                feedbackInputShown: false,
                feedbackInputOverallShown: false,

                // Related to draft comments / annotation retry logic
                pendingFeedbackCountForAllVersions: 0,
                pendingAnnotation: null,
                selectedPerson: null,
                feedbackFilterDescription: '',
                showCompressedFeedbackFilter: false,
                showSharedFolderPermission: true
            };

            //Initialize the feedback synchronizer with the right documentState which contains the right VM objects
            FeedbackSyncService.initScope($scope.documentState);
            FeedbackService.startFeedbackSyncTask();

            
            $scope.processFirstRunExp();
            $scope.documentState.documentViewerBridge = new DocViewerBridge(window);
            $scope.$on('$destroy', function() {
                //VERY IMPORTANT: the corressponding bridge layer for this document load has to be destroyed.
                $scope.documentState.documentViewerBridge.destroy();
                FeedbackSyncService.unsetScope();
            });

            $scope.resourceInfo = {
                resourceType: AppConstants.ResourceTypes.FILE,
                Id: $scope.documentState.documentId
            };

            $scope.RoleTypes = AppConstants.RoleTypes;

            if ($scope.documentState.officeEditorMode) {
                $scope.layout.showRightSidebar = false;
            }
            // Related to expanding users in groups in People tab
            $scope.groupInfo = {
                expandGroupShown: false,
                selectedGroup: null,
                groupMembers: [],
                role: null,
                hideShowMore: false,
                errorText: ''
            };

            // SECTION: Modal State variables
            $scope.requestFeedback = {
                hasDeadline: false,
                isEmailMessageManualLocked: false,
                DEADLINE_HOURS: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
                DEADLINE_MINUTES: ['00', '15', '30', '45'],
                DEFAULT_DEADLINE: ' 05:00 PM',
                earliestDeadline: null,
                deadlineDatetime: '',
                deadlineDate: '',
                deadlineHour: '05',
                deadlineMinute: '00',
                deadlineAMPM: 'PM',
                deadlineTimeMessage: '',
                deadlineTime: null,
                message: ''
            };

            $scope.metadata = null;
            $scope.userInfo = $scope.user = userInfo;
            $scope.documentVersionIdToVersionNumberMap = {};
            $scope.permissonsLoaded = false;
            $scope.documentVersionsLoaded = false;
            $scope.feedbackIdToObjectMap = {};

            $scope.sidebar = defaultSidebar;
            $scope.ViewTypes = viewTypes;
            $scope.SkuTypes = skuTypes;
            $scope.RightTabTypes = rightTabTypes;
            $scope.DocumentStatus = documentStatus;
            $scope.documentSourceUrl = '';
            $scope.toHumanReadableDate = DateTimeService.getHumanReadableDate;
            $scope.inDocumentSearchEnabled = true;
            $scope.searchShown = false;
            $scope.isBasicUser = (userInfo.SkuType === $scope.SkuTypes.BASIC) ? true : false;
            $scope.isMinimalUser = userInfo.MinimalUser;
            $scope.showEditDropdown = EndpointService.isPreviewSite() || EndpointConfig.stage(RegionService.getRealRegion()) !== 'PROD' || $rootScope.isFeatureEnabled($rootScope.Features.UI.SHOW_EDIT_DROPDOWN);
            
            if (FeatureManagerService.isFeatureEnabled(Features.DocumentViewer.ONLINEEDITING)) {
                OrganizationService.getFeatureDetails(AppConstants.ORG_FEATURES.ONLINE_EDITING).then(function(data) {
                    if (angular.equals(data, {})) {
                        return;
                    }
                    $rootScope.onlineEditingEnabled = data.Enabled;
                }, function(response) {
                    $rootScope.onlineEditingEnabled = false;
                });
            }

            function sendFeedbackToDocumentBridge() {
                if (!$scope.permissonsLoaded || !$scope.documentState.feedbackLoaded) {
                    return;
                }
                var pageVsAnnotationList = {},
                    feedbackSections = $scope.documentState.feedbackListMap[$scope.documentState.activeVersion.VersionId];
                if (feedbackSections) {
                    feedbackSections.forEach(function(feedbackSection) {
                        if (feedbackSection.isVisible) {
                            pageVsAnnotationList[feedbackSection.marker] = feedbackSection.filter(function(feedbackObj) {
                                return feedbackObj.isVisible && feedbackObj.AnnotationStatus !== AppConstants.FeedbackTypes.FEEDBACK_TYPE_INPUT;
                            });
                        }
                    });
                    delete pageVsAnnotationList[0]; //We don't have to send Overall Comments to Document Viewer
                    angular.forEach(pageVsAnnotationList, function(value, key) {
                        if (!value) {
                            return;
                        }
                        value.forEach(function(annotation) {
                            if (annotation.AnnotationStatus !== AppConstants.FeedbackTypes.FEEDBACK_TYPE_DRAFT) {
                                if (DocumentStateService.feedback.users[annotation.Contributor.Id]) {
                                    //For safety reasons, check if the user exists in the the above map
                                    annotation.color = DocumentStateService.feedback.users[annotation.Contributor.Id].color;
                                } else {
                                    annotation.color = AppConstants.DRAFT_COLOR;
                                }
                            } else {
                                annotation.color = AppConstants.DRAFT_COLOR;
                            }
                        });
                    });
                    $scope.documentState.documentViewerBridge.receiveAnnotations(pageVsAnnotationList);
                }
            }

            function loadCommentsAndAnnotations() {
                // skip loading feedback if the user only has viewer permissions for this document.
                if($scope.isViewer()){
                    $log.debug("Skipping loading feedback for document : " + $scope.metadata.Id + " because userid : " + userInfo.Id + " has view only permissions");
                } else {

                    var allVersionFeedbackApiLatency = ClientMetricsService.startNewLatencyEvent({
                        event: MetricEvents.FEEDBACK_PANEL_EVENTS.API_LATENCY_FOR_FETCHING_ALL_VERSION_FEEDBACK,
                    documentId: $scope.metadata.Id,
                    versionId: $scope.metadata.VersionMetadata.VersionId
                    });

                    var allVersionFeedbackRenderLatency = ClientMetricsService.startNewLatencyEvent({
                        event:MetricEvents.FEEDBACK_PANEL_EVENTS.RENDERING_LATENCY_ALL_VERSION_FEEDBACK,
                        documentId: $scope.metadata.Id,
                        versionId: $scope.metadata.VersionMetadata.VersionId
                    });

                    $scope.documentState.feedbackLoadingPromise = FeedbackService.getFeedbackMapForAllVersions($scope.metadata.Id, nonDraftVersionIds);
                        $scope.documentState.feedbackLoadingPromise.then(function(value) {
                        $scope.documentState.feedbackListMap = value;
                        $scope.populateResolverInfo();
                    }, function(value) {
                        $scope.documentState.feedbackListMap = value;
                        $scope.documentState.partialFeedbackLoaded = true;
                    }).finally(function() {

                        //emitting two metrics for comparision
                        var feedbackRenderingLatency = $rootScope.metricServiceInstance.newAnonymousLatencyMetric();
                        $scope.registerPostDigestCallback(function() {
                            feedbackRenderingLatency.emitMetricWithMethodName('DocumentViewer.FeedbackRendered');
                        });
                        setTimeout(function() {
                            feedbackRenderingLatency.emitMetricWithMethodName('DocumentViewer.FeedbackRendered_Next_Tick');
                        });
                        if(feedbackFetchingLatency){
                            feedbackFetchingLatency.stopAndEmitMetric();
                            feedbackFetchingLatency = null;
                        }
                        allVersionFeedbackApiLatency.stopAndRecordLatency();
                        setTimeout(function() {
                            allVersionFeedbackRenderLatency.stopAndRecordLatency();
                        });
                        $scope.documentState.feedbackLoaded = true;
                        $scope.addUsersFromFeedbackMapToList();
                        var result = FeedbackService.computeDocVersionCommentsAndPendingFeedback($scope.documentState.feedbackListMap);
                        $scope.documentState.documentVersionCommentsMap = result.documentVersionCommentsMap;
                        $scope.documentState.pendingFeedbackCountForAllVersions = result.pendingFeedbackCountForAllVersions;
                        $scope.applyFeedbackFilters();
                        $scope.documentState.userToFeedbackCountMap = FeedbackService.getUserToFeedbackCount($scope.documentState.feedbackListMap);

                         sendFeedbackToDocumentBridge();
                    });
                }
            }

            var documentRenderingLatency = !$rootScope.uploadDocumentLatency ? $rootScope.metricServiceInstance.newLatencyMetric('DocumentViewer.FirstBridgeInitialized') : null; // only creates if fresh document and not an upload. 

            $scope.documentState.documentViewerBridge.on(DocViewerEvents.BRIDGE_INITIALIZED, function() {
                var region = RegionService.getRegion(),
                    stage = region ? EndpointConfig.stage(region) : null;

                $scope.documentState.documentViewerBridge.updateConfiguration({
                    allowFeedback : !!$scope.allowFeedback(),
                    documentId : $scope.documentState.documentId,
                    versionId : $scope.documentState.activeVersion.VersionId,
                    userId: userInfo.Id,
                    region: region,
                    stage: stage,
                    isViewer : $scope.isViewer()
                });
            });

            $scope.documentState.documentViewerBridge.on(DocViewerEvents.DOCUMENT_LOADED, function() {
                if (documentRenderingLatency) {
                    documentRenderingLatency.stopAndEmitMetric();
                    documentRenderingLatency = null; //stop emitting again
                }
                if($rootScope.shouldHandlePdfLoadMetric){
                    const LatencyMetricEntry = $rootScope.LatencyMetricEntry;
                    const pdfLoadMetric = new LatencyMetricEntry('PDF_OVERALL_LOAD');

                    pdfLoadMetric.Values = performance.now();

                    $rootScope.metricServiceInstance.putMetric(pdfLoadMetric);
                    $rootScope.shouldHandlePdfLoadMetric = null;
                }
                if($rootScope.uploadDocumentLatency){
                    $rootScope.uploadDocumentLatency.stopAndEmitMetric();
                    $rootScope.uploadDocumentLatency = null;
                }
                
                $rootScope.$applyAsync(function() {
                    $scope.documentState.pdfDataLoaded = true;
                });
            });

            $scope.documentState.documentViewerBridge.on(DocViewerEvents.RELOAD_ANNOTATIONS, function() {
                sendFeedbackToDocumentBridge();
                if ($scope.sidebar.tabName === rightTabTypes.FEEDBACK_TAB) {
                    $scope.documentState.documentViewerBridge.showAnnotations();
                }
                $rootScope.$applyAsync(function() {
                    $scope.documentState.pdfDataLoaded = true;
                });
            });

            //When click/draw rectangle/text selection happens on document view, emit a CustomClickEvent for the floatingContainer to toggle menus etc.,
            $scope.documentState.documentViewerBridge.on(DocViewerEvents.CLICKED_OUTSIDE_IN_PAGE, function() {
                $rootScope.$applyAsync(function() {
                    $rootScope.$broadcast(SignalProvider.CustomClickEvent);
                });
            });
            $scope.documentState.documentViewerBridge.on(DocViewerEvents.RECTANGLE_DRAWN_IN_PAGE, function() {
                $rootScope.$applyAsync(function() {
                    $rootScope.$broadcast(SignalProvider.CustomClickEvent);
                });
            });
            $scope.documentState.documentViewerBridge.on(DocViewerEvents.TEXT_SELECTED_IN_PAGE, function(action) {
                $rootScope.$applyAsync(function() {
                    $rootScope.$broadcast(SignalProvider.CustomClickEvent);
                });
            });

            //Emit all actions sent by the bridge layer to Client Metrics Service
            $scope.documentState.documentViewerBridge.on('*', function(action) {
                if (!action) {
                    return;
                }
                ClientMetricsService.addLogsToSession({
                    event: "DOCUMENT_VIEWER_BRIDGE_EVENT",
                    metadata: action.type,
                    documentId : $scope.documentState.documentId,
                    versionId : $scope.documentState.activeVersion.VersionId
                });
            });

            $scope.documentState.documentViewerBridge.on(DocViewerEvents.RECTANGLE_DRAWN_IN_PAGE, askTheUserToExpandRightPanel);

            function askTheUserToExpandRightPanel() {
                $rootScope.$apply(function() {
                    if (!$scope.layout.showRightSidebar) {
                        MessageManager.addInfoMessage($translate.instant('RIGHT_NAV.EXPAND_RIGHT_PANEL_FOR_FEEDBACK'));
                    }
                });
            }

            $scope.isDefaultFeedbackFilterState = function() {
                return angular.equals($scope.documentState.commentFilterPreferenceMap, AppConstants.FEEDBACK_FILTER_INTIAL_STATE);
            };

            $scope.isDocumentCheckedout = function() {
                return $scope.metadata.CheckoutInfo ? true : false;
            };

            $scope.isDocumentCheckedOutByLoggedInUser = function() {
                return $scope.metadata.CheckoutInfo && $scope.metadata.CheckoutInfo.CheckoutUserId === userInfo.Id;
            };

            $scope.canCheckout = function() {
                return $scope.documentState.checkinCheckoutEnabled && !$scope.metadata.CheckoutInfo &&
                    hasRightForDocument(permissions.CHECKOUT) && !$scope.isBasicUser;
            };

            $scope.canCheckin = function() {
                var hasAtLeastOneDraftVersion = $scope.documentState.documentVersions.some(function(version) {
                    return version.VersionStatus === AppConstants.DOCUMENT_VERSION_STATUS.DRAFT;
                });
                return hasAtLeastOneDraftVersion && $scope.documentState.checkinCheckoutEnabled && $scope.metadata.CheckoutInfo && $scope.metadata.CheckoutInfo.CheckoutUserId === userInfo.Id && hasRightForDocument(permissions.CHECKIN) && !$scope.isBasicUser;
            };

            $scope.canDiscardCheckout = function() {
                var metadata = $scope.metadata;
                return $scope.documentState.checkinCheckoutEnabled && metadata.CheckoutInfo &&
                        //Either the LockType has to equal 'USER' or it shouldn't be defined at all
                        (!metadata.CheckoutInfo.LockType || metadata.CheckoutInfo.LockType === AppConstants.LOCK_TYPES.USER) &&
                     (metadata.CheckoutInfo.CheckoutUserId === userInfo.Id || hasRightForDocument(permissions.DISCARD_CHECKOUT)) &&
                     !$scope.isBasicUser;
            };

            $scope.canRequestCheckin = function() {
                var metadata = $scope.metadata;
                return hasRightForDocument(permissions.CHECKOUT) && $scope.documentState.checkinCheckoutEnabled &&
                    //Either the LockType has to equal 'USER' or it shouldn't be defined at all
                    metadata.CheckoutInfo && (!metadata.CheckoutInfo.LockType || metadata.CheckoutInfo.LockType === AppConstants.LOCK_TYPES.USER) &&
                    metadata.CheckoutInfo.CheckoutUserId !== userInfo.Id;
            };

            $scope.requestCheckInHandler = function() {
                var isProprietor = false;
                if (DocumentStateService.currentUserRoles) {
                    isProprietor = DocumentStateService.currentUserRoles.some(function(role) {
                        return role.role === globalRoles.OWNER || role.role === globalRoles.COOWNER;
                    });
                }
                $scope.requestCheckin($scope.metadata.Id, $scope.metadata.CheckoutInfo.CheckoutUserName, isProprietor);
            };

            $scope.documentViewUnlockHandlerFromFeedbackPanel = function() {
                $scope.documentViewUnlockHandlerCommon();
            };

            $scope.documentViewUnlockHandlerCommon = function() {
                var promise;
                if ($scope.metadata.CheckoutInfo && $scope.metadata.CheckoutInfo.LockType === AppConstants.LOCK_TYPES.APP) {
                    //no-op
                    return $q.reject();
                }
                if ($scope.metadata.CheckoutInfo) {
                    if ($scope.metadata.CheckoutInfo.CheckoutUserId === userInfo.Id) {
                        promise = $scope.unlockDocumentCommon($scope.metadata.Id, $scope.documentState.activeVersion.Name);
                    } else {
                        promise = $scope.discardCheckoutForProprietor($scope.metadata.Id, $scope.metadata.VersionMetadata.Name);
                    }
                    promise.then(function() {
                        //If the modal promise is resolved, then we'll reload the view. Otherwise not becuase we're showing an error
                        $scope.getDocument();
                    });

                    return promise;
                }
            };

            /**
             * This is called from Security tab
             */
            $scope.discardChangesAndUnlockHandler = function() {
                var promise;
                if ($scope.isDocumentCheckedOutByOtherUser($scope.metadata)) {
                    promise = $scope.discardCheckoutForProprietor($scope.metadata.Id, $scope.metadata.VersionMetadata.Name);
                } else {
                    promise = $scope.discardCheckoutCommonCinCoutCtrl($scope.metadata.Id);
                }
                promise.then(function() {
                    $scope.getDocument();
                });
            };

            $scope.formattedCheckoutTime = function() {
                if (!$scope.metadata.CheckoutInfo || !$scope.metadata.CheckoutInfo.CheckoutTime) {
                    return '';
                }
                return moment(new Date($scope.metadata.CheckoutInfo.CheckoutTime)).fromNow();
            };

            $scope.checkoutHandler = function() {
                ClientMetricsService.addLogsToSession({
                    event: UIEvents.DOCUMENT_VIEWER.DROPDOWN_MENU_CLICKS.CHECKOUT,
                    metadata: userInfo.Id,
                });

                return $scope.checkoutDocumentCommon($scope.metadata.Id).then(function(response) {
                    $scope.metadata.CheckoutInfo = response.data.CheckoutInfo;
                });
            };

            $scope.lockButtonClickedHandler = function() {
                if ($scope.isBasicUser || $scope.isMinimalUser) {
                    return;
                }

                // Lock when the document is unlocked
                if ($scope.canCheckout()) {
                    $scope.checkoutHandler();
                    return;
                }

                /* The order matters. Do not check if the user can request checkin if the user can checkin */
                // Unlock when the document is locked and user can do so
                if ($scope.canDiscardCheckout() || $scope.canCheckin() || $scope.isDocumentCheckedOutByAnApp($scope.metadata)) {
                    $scope.documentViewUnlockHandlerCommon();
                }

                // request unlock when the document is locked but user cannot unlock
                else if ($scope.canRequestCheckin()) {
                    $scope.requestCheckInHandler();
                }
            };

            $scope.showRightTab = function(tabName) {
                return showRightTabBy(SignalProvider.Sidebar.ChangeRight, tabName);
            };

            $scope.showRightTabSliding = function(tabName) {
                return showRightTabBy(SignalProvider.Sidebar.SlideRight, tabName);
            };

            $scope.goToPreview = function(id) {
                $location.url('/document/' + id);
            };

            $scope.goToParent = function(id) {
                var showMyDocs = false,
                    showRecycleBin = false;
                if (userInfo.RootFolderId === id) {
                    showMyDocs = true;
                }
                if (userInfo.RecycleBinFolderId === id) {
                    showRecycleBin = true;
                }
                LayoutManager.goToParent(id, showMyDocs, showRecycleBin);
            };

            $scope.hasSharePermission = function() {
                return hasRightForDocument(permissions.SHARE);
            };

            $scope.hasShareLinkPermission = function() {
                return hasRightForDocument(permissions.SHARE);
            };

            $scope.getShareLabel = function() {
            	return (FeatureManagerService.isFeatureEnabled(Features.UI.ANONYMOUS_LINK))?
            			$translate.instant('FILE_ACTIONS.SHARE_INVITE') : $translate.instant('FILE_ACTIONS.SHARE');
            };

            $scope.getShareLinkLabel = function() {
              return $scope.hasShareLinkCurrentDocument()? $translate.instant('SHARE_LINK.DOCUMENT_VIEWER.DOCUMENT_LINK_TOOLTIP')
                          : $translate.instant('FILE_ACTIONS.SHARE_ANONYMOUSLY');
            };

            $scope.hasShareLinkCurrentDocument = function(){
              return $scope.metadata.SharedAnonymously || $scope.metadata.SharedWithOrganization;
            };

            $scope.isOfficeFile = function(){
                if (_.endsWith($scope.documentState.activeVersion.Name, AppConstants.WOPI_TEST_EXT)) {
                    return true;
                }
                return ContentTypeFormatter.isOfficeFile($scope.documentState.activeVersion.ContentType);
            };

            $scope.isAudioPlayableFile = function(){
                return ContentTypeFormatter.isAudioPlayableFile($scope.documentState.activeVersion.ContentType);
            };

            $scope.isOnlineEditableFileFormat = function() {
                return ContentTypeFormatter.isOnlineEditableFileFormat($scope.documentState.activeVersion.ContentType);
            };

            $scope.isOfficeLegacyFile = function(){
                return ContentTypeFormatter.isOfficeLegacyFile($scope.documentState.activeVersion.ContentType);
            };

            $scope.showOpenWithOffice = function() {
                return !$scope.isFileRecycled() && $rootScope.isO365FeatureEnabled() && $scope.isOfficeFile() && $scope.showDownloadButton();
            };

            $scope.isOfficeLockedByOtherSource = function() {
                return $rootScope.isO365FeatureEnabled() && $scope.isOfficeFile() && $rootScope.office365EditingEnabled && $scope.metadata.CheckoutInfo && !$scope.isDocumentCheckedOutByO365($scope.metadata) && !$scope.isViewer() && $scope.showDownloadButton();
            };

            $scope.showThinkFreeButton =function() {
                return $scope.isFeatureEnabled(Features.DocumentViewer.ONLINEEDITING) && !$scope.isBasicUser && !$scope.isMinimalUser && !$scope.isFileRecycled() && $rootScope.onlineEditingEnabled && !BrowserService.isMobileOrTablet();
            };

            $scope.showAudioPlayer =function() {
                return $scope.isFeatureEnabled(Features.UI.TEXTTOVOICE) && $scope.isAudioPlayableFile() && !$scope.isBasicUser && !$scope.isMinimalUser && !$scope.isFileRecycled() && !BrowserService.isMobileOrTablet();
            };

            $scope.editOnline = function(doc) {
                $location.url('/document/' + doc.Id+ '?editOnline=true');
                var event = {
                    name: "DROPDOWN_EDIT_ONLINE",
                    documentId : doc.Id,
                    versionId : doc.VersionMetadata.VersionId
                };
                ClientMetricsService.addEventToSession(event);
            };

            $scope.openFileInOfficeEditor = function(){
                var path = '/document/' + $scope.documentState.documentId + '?officeEditor=true&versionId=' + encodeURIComponent($scope.documentState.activeVersion.VersionId);
                var event = {
                    event: MetricEvents.O365.OFFICE_FILE_OPENED_BROWSER_VIEW.name,
                    documentId : $scope.documentState.documentId,
                    versionId : $scope.documentState.activeVersion.VersionId,
                    documentType : $scope.documentState.activeVersion.ContentType
                };
                ClientMetricsService.addEventObjectToSession(event);
                $location.url(path);
            };

            $scope.constructOnlineEditorUrl = function() {
                var ONLINE_EDITOR_BASE_URL = EndpointService.hancomEndpoint();
                var editorApp = "WRITE_EDITOR";
                var Settings = '100100';
                var contentType = $scope.documentState.activeVersion.ContentType;
                switch (contentType) {
                    case 'application/vnd.ms-excel':
                    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                        editorApp = "CALC_EDITOR";
                        break;

                    case 'application/vnd.ms-powerpoint':
                    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                        editorApp = "SHOW_EDITOR";
                        break;
                }

                var preferredLanguage = determinePreferredLanguage();

                var workdocsHancomLanguageMap = {
                    "en":"en_US",
                    "de":"de_DE",
                    "es":"es_ES",
                    "fr":"fr_FR",
                    "ja":"ja_JP",
                    "ko":"ko_KR",
                    "pt-br":"pt_BR",
                    "zh-cn":"zh_CN"
                };

                var language = workdocsHancomLanguageMap[preferredLanguage];

                return AuthService.onAccessTokenRefreshTick().then(function() {
                    return TokenService.createSecureTokenHancom($scope.metadata.Id, null, 'UNUSED').then(function(token) {
                        var date = new Date();
                        var currentTimeinMilliseconds = date.getTime();

                        return ONLINE_EDITOR_BASE_URL + encodeURIComponent($scope.documentState.activeVersion.Name) +
                            '/open?app=' + encodeURIComponent(editorApp) +
                            '&lang=' + encodeURIComponent(language) +
                            '&fid=' + encodeURIComponent($scope.metadata.Id) +
                            '&openTimestamp=' + encodeURIComponent(currentTimeinMilliseconds) +
                            '&user_id=' + encodeURIComponent($scope.userInfo.Id) +
                            '&uiOption=' + encodeURIComponent(Settings) +
                            '&region=' + encodeURIComponent(RegionService.getRealRegion()) +
                            '&access_token=' + encodeURIComponent(token);

                    }, function(errorResponse) {
                        $log.log("Unable to get secure token :", errorResponse);
                    });
                });
            };

            $scope.openFileInOnlineEditor = function() {

                return $scope.constructOnlineEditorUrl().then(function(onlineEditingUrl) {
                    $scope.documentState.onlineEditingUrl = onlineEditingUrl;
                    $scope.documentState.onlineEditorMode = true;
                    $scope.layout.showRightSidebar = false;
                    return onlineEditingUrl;
                }, function(errorResponse) {
                    $log.log("Error in openFileInOnlineEditor : ",errorResponse);
                });

            };

            $scope.showDeleteButton = function() {
                if (DocumentStateService.currentUserRoles) {
                    // This is to satisfy the documentation that an inherited contributor can delete files.
                    for (var i = 0; i < DocumentStateService.currentUserRoles.length; i++) {
                        var currentRole = DocumentStateService.currentUserRoles[i];

                        // inherited contributors are contributors whose roletype is INHERITED and principal type is USER
                        if (currentRole.role === globalRoles.CONTRIBUTOR && currentRole.roleType === AppConstants.RoleTypes.INHERITED && currentRole.principalType !== AppConstants.PrincipalTypes.ORGANIZATION) {
                            return DocumentStateService.locationType !== viewTypes.RECYCLE_TYPE;
                        }
                    }
                }

                return DocumentStateService.locationType !== viewTypes.RECYCLE_TYPE &&
                    hasRightForDocument(permissions.DELETE);
            };

            $scope.showFeedbackSettings = $scope.showDeleteButton;

            $scope.showUploadButton = function() {
                // 1. Cannot upload a document version from recycle bin
                // 2. A user without CONTRIBUTE permissions cannot upload a document version
                // 3. User is not anonymous
                // 4. Document is not checked out
                return DocumentStateService.locationType !== viewTypes.RECYCLE_TYPE && hasRightForDocument(permissions.CONTRIBUTE) &&
                    !$scope.layout.isAnonymous && (!$scope.isDocumentCheckedout() || $scope.isDocumentCheckedOutByLoggedInUser());
            };

            $scope.checkUploadPermissionForEdit = function() {
                return DocumentStateService.locationType !== viewTypes.RECYCLE_TYPE && hasRightForDocument(permissions.CONTRIBUTE);
            };

            $scope.showDownloadButton = function() {
                // Download is not supported in the Recycle Bin.
                // 1. Document owner can always download the document version
                // 2. Others can download a document version only when the document owner allows it
                var canDownload = hasRightForDocument(permissions.DOWNLOAD);
                return DocumentStateService.locationType !== viewTypes.RECYCLE_TYPE && canDownload;
            };

            $scope.showDownloadWithCommentsButton = function() {
                var hasRightRolePermission = !$scope.isViewer();
                var canDownload = hasRightForDocument(permissions.DOWNLOAD);
                return DocumentStateService.locationType !== viewTypes.RECYCLE_TYPE && canDownload && hasRightRolePermission;
            };

            $scope.showPermissionDeniedMessage = function() {
                MessageManager.addInfoMessage($translate.instant('FILE_ACTIONS.NO_PERMISSION'));
            };

            $scope.inRecycleBin = function() {
                return $scope.documentState.parentFolderId === userInfo.RecycleBinFolderId;
            };

            $scope.isFileRecycled = function() {
                var isRecycled = ($scope.metadata.ResourceState === "RECYCLED" || $scope.metadata.ResourceState === "RECYCLING" || $scope.inRecycleBin());
                return isRecycled;
            };

            $scope.isAnnotationReady = function() {
                return $scope.documentState.activeVersion.AnnotatedVersionAvailable;
            };

            $scope.showSendMessageButton = function() {
                return hasRightForDocument(permissions.CONTRIBUTE) &&
                    DocumentStateService.locationType !== viewTypes.RECYCLE_TYPE;
            };

            $scope.showVersionSwitcherButton = function() {
                return hasRightForDocument(permissions.CONTRIBUTE) &&
                    $scope.documentState.documentVersions.length > 1 && !$scope.isNoteMode();
            };

            $scope.isNoteMode = function() {
            	return FeatureManagerService.isFeatureEnabled(Features.DocumentViewer.ONLINENOTES) &&
                    $scope.metadata && $scope.metadata.DocumentCategory === AppConstants.DocumentTypes.NOTE;
            };

            $scope.hasContributePermission = function() {
                return hasRightForDocument(permissions.CONTRIBUTE);
            };
            $scope.allowFeedback = function() {
                if (!$scope.documentState.activeVersion) {
                    return false;
                }
                return hasRightForDocument(permissions.CONTRIBUTE) &&
                    !$scope.documentFormData.disableFeedback &&
                    $scope.documentState.activeVersion.VersionStatus !== AppConstants.DOCUMENT_VERSION_STATUS.DRAFT &&
                    DocumentStateService.locationType !== viewTypes.RECYCLE_TYPE;
            };

            // Get thumbnail of a document version
            $scope.getThumbnailUrlMap = function(docVersion) {
                if (docVersion.PdfPreviewStatus === 'ACTIVE') {
                    return docVersion.ThumbnailUrlMap.LARGE;
                } else {
                    return $scope.THUMBNAIL_VIEW_NO_PREVIEW;
                }
            };

            $scope.getPermissionLevel = function(principal) {
                var permissionOrder = [globalRoles.VIEWER, globalRoles.CONTRIBUTOR, globalRoles.COOWNER, globalRoles.OWNER];
                if (!principal || !principal.Role) {
                    //Any undefined/null objects get zero permission level
                    $log.error("Cannot get permission level from the principal. Received : " + principal);
                    return 0;
                }
                // Reviewer role is not available in Rainier, defaulting to Viewer role. 
                if (principal.Role === 'REVIEWER') {
                    return 0;
                }
                return permissionOrder.indexOf(principal.Role);
            };

            $scope.getDocument = function() {
                // Log the time at which GetDocument call has been made
                getDocumentCallTimestamp = new Date();

                function successCallback(response){
                    processDocumentMetadata(response.data);
                    // If there is no active version, set it. Do not change active version if there is already one.
                    if (!$scope.documentState.activeVersion) {
                        $scope.setActiveVersion($scope.metadata.VersionMetadata);
                    }
                }

                function errorCallback(response){
                     if (response.data &&
                         response.data.Message === UNAUTHORIZED_RESOURCE_ACCESS_EXCEPTION &&
                         DocumentStateService.locationType === viewTypes.SHARED_TYPE) {
                        $rootScope.showShared();
                    } else {
                        MessageManager.addErrorMessage(MessageProvider.documentAccessFailDefault);
                    }
                }

                DocumentService.getDocument($scope.documentState.documentId, true)
                .then(successCallback, errorCallback);

            };

            $scope.setActiveVersionById = function(id) {
                var done = $q.defer();

                var versionIndex = $scope.documentVersionIdToVersionNumberMap[id] || $scope.documentState.documentVersions.length;
                if (versionIndex) {
                    $scope.setActiveVersion($scope.documentState.documentVersions[$scope.documentState.documentVersions.length - versionIndex]).then(function() {
                        done.resolve();
                    });
                }

                return done.promise;
            };

            $scope.setActiveVersionByIndex = function(index, delay) {
                if (!delay) {
                    delay = 0;
                }
                $timeout(function() {
                    if (index <= $scope.documentState.documentVersions.length) {
                        $scope.setActiveVersion($scope.documentState.documentVersions[$scope.documentState.documentVersions.length - index]);
                    }
                }, delay);
            };

            $scope.versionDelete = function (event, docVersionId) {
                if (!$scope.isVersionDeleteEnabled) return;
                event.stopPropagation();
                $scope.modals.purgeVersionId = docVersionId;

                var purgeVersionsModal = $uibModal.open({
                    templateUrl: './document-viewer/version_delete_modal.html',
                    controller: 'PurgeDocumentVersionController',
                    scope: $scope
                });

                purgeVersionsModal.result.then(function() {
                    purgeVersionsModal = null;
                }, function() {
                    purgeVersionsModal = null;
                });
                $scope.$on("$destroy", function() {
                    if (purgeVersionsModal) {
                        purgeVersionsModal.close();
                    }
                });
            }

            $scope.setActiveVersion = function(v) {
                var done = $q.defer();

                if (v) {
                    var changed = v.VersionId != DocumentStateService.activeVersionId;
                    // clean up annotations and feedback input
                    if ($scope.documentState.feedbackInputShown) {
                        DocumentUtilities.hideFeedbackInput(false, false);
                    }
                    // Set the currently viewed version of the document.
                    DocumentStateService.activeVersion = v;

                    $scope.documentState.activeVersion = {
                        Name: DocumentStateService.activeVersion.Name,
                        Size: DocumentStateService.activeVersion.Size,
                        ContentType: DocumentStateService.activeVersion.ContentType,
                        Modified: DocumentStateService.activeVersion.Modified,
                        VersionId: DocumentStateService.activeVersion.VersionId,
                        Status: DocumentStateService.activeVersion.Status,
                        VersionStatus: DocumentStateService.activeVersion.VersionStatus,
                        AnnotatedVersionAvailable: DocumentStateService.activeVersion.AnnotatedVersionAvailable,
                        PdfPreviewStatus: DocumentStateService.activeVersion.PdfPreviewStatus
                    };
                    // Clear the rendered pages.
                    document.title = DocumentStateService.activeVersion.Name + ' - ' + AppConstants.APP_NAME;
                    DocumentStateService.activeVersionId = $scope.documentState.activeVersion.VersionId;
                    DocumentStateService.contentType = $scope.documentState.activeVersion.ContentType;
                    $scope.documentState.activeVersionIndex = $scope.documentVersionIdToVersionNumberMap[DocumentStateService.activeVersionId];

                    // clean up annotations and feedback input
                    if ($scope.documentState.feedbackInputShown) {
                        DocumentUtilities.hideFeedbackInput();

                    }
                    if ($scope.documentState.activeVersion.Status === documentStatus.DOCUMENT_STATUS_ACTIVE) {
                        $scope.documentOperationsEnabled = '';
                    } else {
                        $scope.documentOperationsEnabled = 'disabled';
                    }

                    if ($scope.documentState.activeVersion.PdfPreviewStatus === documentStatus.DOCUMENT_STATUS_PENDING_USER_ACTION) {
                        var docId = $scope.documentState.documentId;
                        $log.info("Calling create preview for doc : " + docId + " and version : " + DocumentStateService.activeVersionId);
                        DocumentService.callCreatePreview($scope.documentState.documentId,  DocumentStateService.activeVersionId);
                        // setup timer to retry
                        $scope.$broadcast(SignalProvider.PDF.ScheduleUpdate);
                    } else if ($scope.documentState.activeVersion.PdfPreviewStatus === documentStatus.DOCUMENT_STATUS_PENDING) {
                        // setup timer to retry
                        $scope.$broadcast(SignalProvider.PDF.ScheduleUpdate);
                    } else {
                        //go get 'em
                        if (changed) {
                            $scope.$broadcast(SignalProvider.PDF.PDFViewResetAnnotation);
                            // When the document first loads, the signal to get underlays
                            // and refresh feedback is done on scroll initialize to avoid
                            // timing issues with calling it here. We only trigger a broadcast
                            // for changing the active version after the initial load.
                            if (DocumentStateService.activeVersionId) {
                                $timeout(function() {
                                    $rootScope.$broadcast(SignalProvider.PDF.GetUnderlaysAndRefreshFeedback, DocumentStateService.activeVersionId, false);
                                });
                            }
                            done.resolve();
                        }
                    }
                } else {
                    done.reject();
                }

                return done.promise;
            };

            $scope.getVersionDownload = function(withAnnotation) {
                //Ideally we don't have to pass Anonymous flag to the service to download the file, but
                //the GB service requires Authentication header to be unset for docs shared anonymously
                DocumentService.getDocumentVersionSource($scope.metadata.Id, DocumentStateService.activeVersionId,
                     $scope.passcode, Anonymous)
                .success(function(data) {
                    var source = data.Metadata.Source,
                        sourceUrl = withAnnotation === 'TRUE' ? source.WITH_COMMENTS : source.ORIGINAL;
                    $scope.updateDocumentSourceUrl(sourceUrl, data.Metadata.Size > 0);
                })
                .error(function(data, status, headers, config) {
                	if (data && data.Message) {
                		if (data.Message.indexOf('EntityNotExistsException') >= 0) {
                            MessageManager.addErrorMessage(MessageProvider.documentDownloadFailNotExists);
                        } else if (data.Message.indexOf('UnauthorizedResourceAccessException') >= 0) {
                            MessageManager.addErrorMessage(MessageProvider.documentDownloadFailNoPermission);
                        }
                	} else {
                		MessageManager.addErrorMessage(MessageProvider.moveModalFailLoadingFolder);
                	}
                });
            };

            $scope.showFolder = function(folderId) {
                if (folderId === userInfo.RootFolderId) {
                    $rootScope.showDocs();
                } else if (folderId === userInfo.RecycleBinFolderId) {
                    $rootScope.showRecycle();
                } else {
                    $rootScope.showFolder(folderId);
                }
            };



            $scope.clearFeedback = function(feedbackObj) {
                if (!feedbackObj) {
                    return;
                }

                var metadata = DocumentUtilities.getFeedbackMetadata(feedbackObj);

                if (metadata.highlightBox) {
                    while (metadata.highlightBox.length > 0) {
                        metadata.highlightBox.pop().remove();
                    }
                }

                var id = feedbackObj.AnnotationId || feedbackObj.Commentid;
                delete DocumentStateService.feedbackMetadata[id];
            };

            $scope.showAnnotationsForEveryone = function() {
                $scope.clearFeedbackFilters();
            };

            $scope.showLeaveFeedbackButton = function(docVersionId) {
                return DocumentStateService.activeVersion.VersionId === docVersionId && $scope.metadata.ResourceState !== AppConstants.RESOURCE_STATUS_RECYCLED;
            };

            $scope.canDisplayFeedbackSection = function(versionId, feedbackSection) {
                return feedbackSection.some(function(feedbackObject) {
                        var isAnnotation = DocumentUtilities.isAnnotation(feedbackObject),
                            isComment = DocumentUtilities.isComment(feedbackObject);
                        return (isComment && $scope.canDisplayFeedback(feedbackObject)) ||
                        (isAnnotation && !DocumentUtilities.isAnnotationInput(feedbackObject) && $scope.canDisplayFeedback(feedbackObject)) || DocumentUtilities.isAnnotationInput(feedbackObject);
                    }) || (feedbackSection.title === AppConstants.DOC_LEVEL && $scope.showLeaveFeedbackButton(versionId) && !$scope.documentFormData.disableFeedback);
            };

            $scope.canDisplayFeedback = function(feedbackObject) {
                var preferenceMap = $scope.documentState.commentFilterPreferenceMap;
                if (preferenceMap.version && preferenceMap.version !== feedbackObject.VersionId) {
                    //If the version is set and the ID doesn't match with that of this feedback. Return false
                    return false;
                }
                if ($scope.documentState.selectedPerson && $scope.documentState.selectedPerson.Id !== feedbackObject.Contributor.Id) {
                    if (feedbackObject.Replies) {
                        // If this is a top level feedback object, check if any of its children replies are from this user
                        return feedbackObject.Replies.some(function(replyObj) {
                            return replyObj.Contributor.Id === $scope.documentState.selectedPerson.Id;
                        });
                    } else {
                        //It's top level feedback just return false
                        return false;
                    }
                }
                if (!preferenceMap.mentions) {
                    if (!preferenceMap.drafts && DocumentUtilities.isDraft(feedbackObject)) {
                        //If the drafts filtering control is checked off. This is a draft then don't display
                        return false;
                    }
                    if (!preferenceMap.published && (DocumentUtilities.isPublished(feedbackObject) || DocumentUtilities.isPublishedDeleted(feedbackObject))) {
                        return false;
                    }
                } else if (feedbackObject.Text.indexOf($scope.userInfo.EmailAddress) === -1) {
                    return false;
                }
                if (DocumentUtilities.isPublished(feedbackObject) || DocumentUtilities.isPublishedDeleted(feedbackObject)) {
                    if (!preferenceMap.unresolved && DocumentUtilities.isUnresolved(feedbackObject)) {
                        return false;
                    }
                    if (!preferenceMap.resolved  && DocumentUtilities.isResolved(feedbackObject)) {
                        return false;
                    }
                }
                return true;
            };

            $scope.clearFeedbackFilters = function() {
                $scope.documentState.commentFilterPreferenceMap = angular.copy(AppConstants.FEEDBACK_FILTER_INTIAL_STATE);
                angular.forEach(DocumentStateService.feedback.users, function(user) {
                    user.show = true;
                });
                $scope.documentState.selectedPerson = null;
                $scope.layout.showFilterPanel = false;
                $scope.applyFeedbackFilters();
            };

            $scope.hideFeedbackFilterPanel = function() {
                $scope.layout.showFilterPanel =false;
            };

            $scope.showFeedbackFilterPanel = function() {
            		$scope.layout.showFilterPanel = true;
                    $scope.deselectFeedback();
            };

            $scope.applyFeedbackFilters = function() {
                var foundPrincipalInFeedbackListMap;
                var feedbackListMap = $scope.documentState.feedbackListMap,
                    preferenceMap = $scope.documentState.commentFilterPreferenceMap,
                    documentVersionCommentsMap = $scope.documentState.documentVersionCommentsMap;

                if (preferenceMap.user) {
                    var foundPrincipals = _.find($scope.documentState.principals.all, {
                        Type: collaboratorTypes.USER,
                        Id: preferenceMap.user
                    });
                    //The _.find() method returns undefined when it can't find the user. If anything other than undefined, it'll be the user object
                    if (foundPrincipals) {
                        foundPrincipalInFeedbackListMap = foundPrincipals;
                    } else {
                        //Check in the feedbackListMap, the user could have been removed from the list.
                        Object.keys(feedbackListMap).forEach(function(versionId) {
                            if (!versionId || foundPrincipalInFeedbackListMap) {
                                return;
                            }
                            var feedbackSections = feedbackListMap[versionId];
                            if (!feedbackSections) {
                                return;
                            }
                            feedbackSections.some(function(feedbackSection) {
                                if (!feedbackSection) {
                                    return;
                                }
                                return feedbackSection.some(function(feedbackObj) {
                                    if (feedbackObj.Contributor.Id === preferenceMap.user) {
                                        foundPrincipalInFeedbackListMap = feedbackObj.Contributor;
                                        return true;
                                    }
                                    if (feedbackObj.Replies) {
                                        return feedbackObj.Replies.some(function(feedbackObj) {
                                            if (feedbackObj.Contributor.Id === preferenceMap.user) {
                                                foundPrincipalInFeedbackListMap = feedbackObj.Contributor;
                                                return true;
                                            }
                                        });
                                    }
                                });
                            });
                        });
                    }
                    if (foundPrincipalInFeedbackListMap) {
                        $scope.documentState.selectedPerson = foundPrincipalInFeedbackListMap;
                        $scope.documentState.feedbackFilterDescription = $translate.instant('RIGHT_NAV.SHOW_SOMEONE_FEEDBACK', {
                            GivenName: $rootScope.escapeHTML($scope.documentState.selectedPerson.GivenName),
                            SurName: $rootScope.escapeHTML($scope.documentState.selectedPerson.Surname)
                        });
                    }
                } else {
                    $scope.documentState.selectedPerson = null;
                }

                Object.keys(feedbackListMap).forEach(function(versionId) {
                    if (!versionId) {
                        return;
                    }
                    var feedbackSections = feedbackListMap[versionId];
                    var count = 0;
                    feedbackSections.forEach(function(feedbackSection) {
                        if (!feedbackSection) {
                            return;
                        }
                        feedbackSection.isVisible = $scope.canDisplayFeedbackSection(versionId, feedbackSection);
                        if (feedbackSection.isVisible) {
                            feedbackSection.forEach(function(feedbackObj) {
                                feedbackObj.isVisible = $scope.canDisplayFeedback(feedbackObj);
                                if (feedbackObj.isVisible) {
                                    if ((feedbackObj.CommentStatus || feedbackObj.AnnotationStatus) !== AppConstants.FeedbackTypes.FEEDBACK_TYPE_DELETED) {
                                        count++;
                                    }
                                    if (feedbackObj.Replies) {
                                        feedbackObj.Replies.forEach(function(feedbackObj) {
                                            feedbackObj.isVisible = $scope.canDisplayFeedback(feedbackObj);
                                            if (feedbackObj.isVisible) {
                                                count++;
                                            }
                                        });
                                    }
                                }
                            });
                        } else {
                            //We need to mark all the feedbackObjs in this feedback section as invisible becuase they could be displayed
                            //when user adds a new annotation for the same page.
                            feedbackSection.forEach(function(feedbackObj) {
                                feedbackObj.isVisible = false;
                            });
                        }
                        documentVersionCommentsMap[versionId] = count;
                    });
                });
                $scope.hideFeedbackFilterPanel();
                sendFeedbackToDocumentBridge();
            };

            // when user click 'load more' button
            $scope.showMoreUsers = function() {
                appendMoreUsers();

                // If there are no more users and the marker is not null, make an API call to repopulate the array.
                if (usersInGroup.length === 0 && groupUserMarker) {
                    getUsersInGroup($scope.groupInfo.selectedGroup).then(function() {}, function(error) {
                        $scope.groupInfo.errorText = MessageProvider.requestEntityTooLargeMessage;
                        $scope.groupInfo.hideShowMore = true;
                    });
                }
            };

            $scope.switchTab = function(entityEntry) {
                if (entityEntry.Type === collaboratorTypes.GROUP) {
                    switchToGroup(entityEntry);
                } else {
                    switchToFeedback(entityEntry);
                }
            };

            $scope.isGroupSelected = function(group) {
                return $scope.groupInfo.selectedGroup && $scope.groupInfo.selectedGroup === group;
            };

            $scope.isPersonSelected = function(person) {
                return $scope.documentState.selectedPerson && $scope.documentState.selectedPerson === person;
            };

            $scope.selectVersion = function(docVersion) {
                if (docVersion.VersionId === DocumentStateService.activeVersionId) {
                    return;
                }
                DocumentStateService.feedback.selectedFeedback = null;
                $scope.setActiveVersionById(docVersion.VersionId);
            };

            $scope.selectVersionAndPage = function(docVersion, pageNum) {
                $scope.$broadcast(SignalProvider.PDF.SelectVersionAndPage, docVersion, pageNum);
            };

            $scope.addUserToFeedbackUserMap = function(user) {
            	if (!user) {
            		return;
            	}
                if (!DocumentStateService.feedback.users[user.Id]) {
                    DocumentStateService.feedback.users[user.Id] = user;
                    DocumentStateService.feedback.users[user.Id].color = ANNOTATION_COLORS[DocumentStateService.usersToAnnotationsCount++ % ANNOTATION_COLORS.length];
                }
            };

            $scope.isViewer = function() {
                return $scope.viewOnly(DocumentStateService.currentUserRoles);
            };

            $scope.showRequestAccessButton = function() {
                return $scope.documentState.documentErrorCode === AppConstants.HttpStatuses.NOT_FOUND ||
                    $scope.documentState.documentErrorCode === AppConstants.HttpStatuses.FORBIDDEN;
            };

            $scope.$on('scrollStopped', function(event) {
                if ($scope.sidebar.tabName === rightTabTypes.FEEDBACK_TAB &&
                    !DocumentStateService.doNotScrollComments && DocumentStateService.pageChanged) {
                    DocumentStateService.pageChanged = false;
                }
            });

            $scope.$on(SignalProvider.FeedbackDrawn.AllFeedbackRendered, function(){
                 ClientMetricsService.stopAndRecordDocumentLatencyEvent({
                    name : MetricEvents.DOCUMENT_FEEDBACK_RENDER_LATENCY.name,
                    documentId : $scope.documentState.documentId,
                    versionId : DocumentStateService.activeVersion.VersionId,
                    documentType : DocumentStateService.activeVersion.ContentType,
                    numberOfPages : DocumentStateService.numberOfPages
                });
            });

            $scope.$watch(function($scope) {
                return $scope.documentState.documentVersions.map(function(version) {
                    if (version.VersionStatus === AppConstants.DOCUMENT_VERSION_STATUS.DRAFT) {
                        //When user uploads multiple draft versions, the version ID will be the same. To trigger the watcher in that case,
                        //we'll append Modified date to the string.
                        return version.VersionId + '_' + version.Modified;
                    }
                    return version.VersionId;
                }).join(',');
            }, function(newVal, oldVal) {
                if (newVal === oldVal) {
                    //Sometimes AngularJS calls with same values, guard against it
                    return;
                }
                if (!Document.error) {
                    if ($scope.documentState.documentVersions && $scope.documentState.documentVersions.length > 0) {
                        var versionId = $location.search().versionId || $routeParams.versionId || '';
                        var versionIndex = $scope.documentVersionIdToVersionNumberMap[versionId] || 1;
                        if (versionIndex) {
                            // If a new version is added, add it to the version number map
                            $scope.documentVersionIdToVersionNumberMap[$scope.documentState.documentVersions[0].VersionId] = $scope.documentState.documentVersions.length;
                            // Check occurence of ',' becuase the string is concatenated by ',' above
                            var numOfVersionsPrev = oldVal? oldVal.split(',').length: 0,
                                numOfVersionsNew = newVal? newVal.split(',').length: 0;
                            var isAddingNewVersion = numOfVersionsNew > numOfVersionsPrev;
                            // Check if the active version is still in document version list. If it is not longer there, reset the active version
                            // to the latest version of the document
                            var isActiveVersionBeenRemoved = !$scope.documentState.documentVersions[$scope.documentState.activeVersion.VersionId];
                            if (isAddingNewVersion || isActiveVersionBeenRemoved) {
                                $scope.setActiveVersion($scope.documentState.documentVersions[versionIndex - 1]);
                            }
                        }
                    }
                }
            });

            // Notifications related methods
            $scope.currentDocumentPreferences = {};
            $scope.areNotificationSettingsEnabled = false;
            $scope.notificationsDisabledState = false;

            function getDocumentNotificationSettings() {
                 if(FeatureManagerService.isFeatureEnabled(Features.UI.DISABLE_NOTIFICATIONS)){
                    $scope.areNotificationSettingsEnabled = true;
                    UserService.getUserResourcePreferences($scope.documentState.documentId).then(function(response){
                        $scope.currentDocumentPreferences = response.data.UserResourcePreferences;
                        $scope.notificationsDisabledState = !$scope.currentDocumentPreferences.NotificationPreferences.EnableAllNotifications;
                    }, function(errorResponse){
                    });
                 }
            }

            getDocumentNotificationSettings();

            $scope.toggleDocumentPreferences = function(){
                $scope.notificationsDisabledState = !$scope.notificationsDisabledState;
                $scope.currentDocumentPreferences.NotificationPreferences.EnableAllNotifications = !$scope.notificationsDisabledState;

                UserService.updateUserResourcePreferences($scope.documentState.documentId, $scope.currentDocumentPreferences).then(function(response){
                    $scope.currentDocumentPreferences = response.data.UserResourcePreferences;
                    if($scope.notificationsDisabledState === true){
                        MessageManager.addSuccessMessage(MessageProvider.disableDocumentNotificationsSuccess);
                    } else{
                        MessageManager.addSuccessMessage(MessageProvider.enableDocumentNotificationsSuccess);
                    }
                }, function(errorResponse){
                    MessageManager.addErrorMessage(MessageProvider.disableDocumentNotificationsFailure);
                    $scope.notificationsDisabledState = !$scope.notificationsDisabledState;
                });
            };

            //use metadata information if documentVersions info is null
            $scope.$watch('metadata', function(newVal, oldVal) {
                if ((!$scope.documentState.documentVersions || $scope.documentState.documentVersions.length === 0) && $scope.metadata) {
                    $scope.setActiveVersion($scope.metadata.VersionMetadata);
                }
            }, true);

            $scope.$on(SignalProvider.Permission.PermissionUpdated, function() {
                $scope.getDocument();
            });

            $scope.$on('$destroy', function() {
                $rootScope.$broadcast(SignalProvider.Window.CloseModals);
            });

            $scope.$on(SignalProvider.Feedback.ClearFeedbackFilter, function() {
                $scope.clearFeedbackFilters();
            });

            $scope.$on(SignalProvider.Task.AccessRequestCreated, function() {
                $scope.userRequestedForThisDocAlready = true;
            });

            // Reset group variables after switch back to people tab
            $scope.$on(SignalProvider.Group.ClearExpandingGroup, function() {
                $scope.groupInfo.groupMembers = [];
                $scope.groupInfo.hideShowMore = false;
                $scope.groupInfo.expandGroupShown = false;
                $scope.groupInfo.selectedGroup = null;
                $scope.groupInfo.errorText = '';
                usersInGroup = [];
                groupUserMarker = null;
            });

            $scope.$on('$routeChangeStart', function(next, current) {
                DocumentStateService.pdfReady = false;
            });

            $scope.$on(SignalProvider.Document.Uploaded, function() {
                // Reset the start timestamp because the controller instance is the same
                // but we are now tracking the time for a newly uploaded version of the document
                initializeDocumentViewTimeEvent();
                $rootScope.uploadDocumentLatency = $rootScope.metricServiceInstance.newLatencyMetric('DocumentViewer.DocumentUpload');
                // Get the document activity feed and show the animation
                 $log.log("SignalProvider.Document.Uploaded inside DocumentController");
                // If a user accesses a file while it's being uploaded, refresh the view after the upload is complete.
                $scope.getDocument();
            });

            $scope.$on(SignalProvider.Feedback.GetDocumentActivityFeed, function() {
                // Get the document activity feed and show the animation
                   $log.log("Not switching to Activity Tab on Signal reception.");
            });

            $scope.$watch("sidebar.tabs", function(){
              var getParams = $location.search();
              if (getParams.show) {
                  $scope.sidebar.tabName = getParams.show;
                  if ($scope.sidebar.tabs.indexOf($scope.sidebar.tabName) === -1) {
                      $scope.sidebar.tabName = $scope.sidebar.tabs[0];
                  }
                  $scope.showRightTab($scope.sidebar.tabName);
              }
            });

            // Main
            ClientMetricsService.addPageViewToSession();

            if (!Document.error) {
                feedbackFetchingLatency = $rootScope.metricServiceInstance.newLatencyMetric('DocumentViewer.FeedbackFetching');
                processDocumentMetadata(Document.data);
                
                $scope.setActiveVersion($scope.metadata.VersionMetadata);
                // init OfficeEditorController only after setting the active version because
                // the active version is needed during the initialization.
                if ($scope.documentState.officeEditorMode) {
                    OfficeEditorController.initScope($scope, userInfo);
                }
                updateImageNavInfo();

                $scope.layout.showLeftSidebar = false;

                if ($routeParams.editOnline) {
                    if (FeatureManagerService.isFeatureEnabled(Features.DocumentViewer.ONLINEEDITING)){
                        OrganizationService.getFeatureDetails(AppConstants.ORG_FEATURES.ONLINE_EDITING).then(function(data){
                            if (angular.equals(data, {})) {
                                return;
                            }
                            $rootScope.onlineEditingEnabled = data.Enabled;
                            if($scope.showThinkFreeButton()) {
                                ClientMetricsService.addPageViewWithDocIdToSession('HANCOM_EDIT_ONLINE',$scope.metadata.Id);
                                $scope.layout.hasRightSidebar = false;
                                $scope.openFileInOnlineEditor();
                            }
                        },function(){
                            $rootScope.onlineEditingEnabled = false;
                        });
                    }

                }

                // no right side bar should be shown for minimal users
                if($scope.isMinimalUser === true){
                    $scope.layout.hasRightSidebar = false;
                }

                var nonDraftVersionIds = [];
                
                var deRegWatch = $scope.$watch('permissonsLoaded && documentVersionsLoaded', function(newVal, oldVal) {
                    if (newVal === oldVal || !newVal) {
                        return;
                    }
                    deRegWatch();
                    $scope.documentState.documentVersions.forEach(function(v) {
                        if (v.VersionStatus !== AppConstants.DOCUMENT_VERSION_STATUS.DRAFT) {
                            nonDraftVersionIds.push(v.VersionId);
                        }
                    });
                    loadCommentsAndAnnotations();
                });
            } else {
                $scope.documentState.documentErrorCode = Document.error.status;
                $scope.permissonsLoaded = true;
                $scope.sidebar = {
                    tabs: [],
                    tabName: '',
                    selectedIndex: -1
                };
                $scope.layout.hasRightSidebar = false;
                $scope.layout.showLeftSidebar = true;
            }

            // Anonymous sharing needs password to be seen
            if (Document.passcode) {
            	$scope.passcode = Document.passcode;
            }

            // Ensure anonymous display options
            if (Anonymous) {
            	$scope.layout.showRightSidebar = false;
            }

            // Old Perfect Scrollbar Trigger to load the doc
            DocumentStateService.pdfReady = true;

            $rootScope.shouldPushToNova().then(function(pushToNova) {
                    if(pushToNova){
                        $rootScope.forceUserToNovaMigration()
                    }
                }
            );
        }

        $scope.isNativeRenderingSupported = NativeRenderingUtils.isNativeRenderingSupported;

        /**
         * We need to add users that are present in the feedback to DocumentStateService.feedback.users. If some users are removed after they've added
         * feedback such users won't be present in thte group.
         */
        $scope.addUsersFromFeedbackMapToList = function() {
            Object.keys($scope.documentState.feedbackListMap).forEach(function(versionId) {
                var feedbackSections = $scope.documentState.feedbackListMap[versionId];
                feedbackSections.forEach(function(feedbackSection) {
                    feedbackSection.forEach(function(feedbackObj) {
                        $scope.addUserToFeedbackUserMap(feedbackObj.Contributor);
                        if (feedbackObj.Replies) {
                            feedbackObj.Replies.forEach(function(feedbackObj) {
                                $scope.addUserToFeedbackUserMap(feedbackObj.Contributor);
                            });
                        }
                    });
                });
            });
        };

        $scope.populateResolverInfo = function() {
            var userIds = [];
            if (!$scope.documentState.feedbackListMap) {
                return;
            }
            angular.forEach($scope.documentState.feedbackListMap, function(feedbackSections, versionId) {
                if (!versionId || !feedbackSections.length) {
                    return;
                }
                feedbackSections.forEach(function(feedbackSection) {
                    feedbackSection.forEach(function(feedbackObj) {
                        if (feedbackObj.ResolutionInfo && feedbackObj.ResolutionInfo.UserId) {
                            userIds.push(feedbackObj.ResolutionInfo.UserId);
                        }
                    });
                });
            });
            UserCollectionService.getUserCollection(userIds).then(applyUserInfoToResolutionInfo);
            function applyUserInfoToResolutionInfo(users) {
                var usersMap = {};
                users.forEach(function(User) {
                    usersMap[User.Id] = User;
                });
                angular.forEach($scope.documentState.feedbackListMap, function(feedbackSections, versionId) {
                    if (!versionId || !feedbackSections.length) {
                        return;
                    }
                    feedbackSections.forEach(function(feedbackSection) {
                        feedbackSection.forEach(function(feedbackObj) {
                            if (feedbackObj.ResolutionInfo && feedbackObj.ResolutionInfo.UserId) {
                                feedbackObj.ResolutionInfo.User = usersMap[feedbackObj.ResolutionInfo.UserId];
                            }
                        });
                    });
                });
            }
        };

        $scope.toggleOrShowRightPanelWithTab = function(tabName) {
            // If right panel is shown and has the same tabname, toggle
            if ($scope.layout.showRightSidebar === true && $scope.sidebar.tabName === tabName) {
                $scope.toggleRightSidebar();
                return;
            }
            // Else, show right panel with given tabname
            $scope.layout.showRightSidebar = true;
            $scope.showRightTab(tabName);
        };

        function hasRightForDocument(rightName) {
            var hasRight = DocumentStateService.userRights && DocumentStateService.userRights.contains(rightName);
            return hasRight;
        }

        function showRightTabBy(action, tabName) {
            var completed = $q.defer();
            if(tabName === "Feedback"){
                ClientMetricsService.startLatencyEvent(MetricEvents.DOCUMENT_FEEDBACK_RENDER_LATENCY);
            }

            $timeout(function() {
                $scope.$broadcast(action, tabName);
                completed.resolve();
            }, 0);
            $scope.layout.showRightTabCompleted = completed;
            return completed.promise;
        }

        function processDocumentVersionIdToVersionNumberMap(versions) {
            var versionMap = {},
                i;

            for (i = 0; i < versions.length; i++) {
                versionMap[versions[i].VersionId] = (versions.length - i);
            }
            return versionMap;
        }
        
        $scope.hasExplicitEditPermissionForShareLinkDocument = function() {
            if (DocumentStateService.currentUserRoles) {
                for (var i = 0; i < DocumentStateService.currentUserRoles.length; i++) {
                    var currentRole = DocumentStateService.currentUserRoles[i];

                    // If a document is Share Link with Edit permission, an owner or co-owner is free to edit. 
                    if (currentRole.role === globalRoles.OWNER || currentRole.role === globalRoles.COOWNER) {
                        return true;
                    }
                    
                    // If a document is Share Link with Edit permission, a contributor can only edit if it has principal 
                    // as USER or GROUP (only people who has explicit permission as user or group in this document)
                    if (currentRole.role === globalRoles.CONTRIBUTOR 
                        && (currentRole.principalType === AppConstants.PrincipalTypes.USER 
                            || currentRole.principalType === AppConstants.PrincipalTypes.GROUP)) {
                        
                        return true;
                    }
                }
            }
            return false;
        }

        $scope.viewOnly = function(currentUserRoles) {
            if (currentUserRoles) {
                for (var i = 0; i < currentUserRoles.length; i++) {
                    if (currentUserRoles[i].role !== globalRoles.VIEWER) {
                        return false;
                    }
                }
            }
            return true;
        };

        //This flag has impact on the feedback capabilities in the PDF viewer
        $scope.$watch('allowFeedback()', function(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            $scope.documentState.documentViewerBridge.updateConfiguration({
                allowFeedback : !!$scope.allowFeedback()
            });
        });

        function processDocumentMetadata(data) {
            data = angular.fromJson(data);
            if (!data) {
                return;
            }
            $scope.metadata = data.Metadata;
            $scope.metadata.VersionMetadata.VersionId = data.Metadata.VersionMetadata.Id;

            //When we get the "CommentsLocked" flag we'll get it in small case
            $scope.documentFormData.disableFeedback = ($scope.metadata.CommentsLocked || '').toLowerCase() === "true";
            if ($scope.metadata.DocumentCategory === AppConstants.DocumentTypes.NOTE) {
            	$scope.documentFormData.disableFeedback = true;
            	$scope.documentFormData.disableFilter = true;
            }

            $scope.documentState.parentFolderId = $scope.metadata.ParentFolderId;

            DocumentService.describeAllDocumentVersions($scope.metadata.Id, true, Document.passcode).then(function successCallback(response){
                var userIds = new Set();

                var docVersions = response.data.DocumentVersions.map(function(versionMetadata) {
                    versionMetadata.VersionId = versionMetadata.Id;
                    userIds.add(versionMetadata.CreatorId);
                    return versionMetadata;
                });
                $scope.documentState.documentVersions = docVersions;

                UserCollectionService.getUserCollection(Array.from(userIds)).then(function (users) {
                    var usersMap = {};
                    users.forEach(function(User) {
                        usersMap[User.Id] = User;
                    });
                    docVersions.forEach(function (versionMetadata) {
                        if (versionMetadata.CreatorId && usersMap[versionMetadata.CreatorId]) {
                            versionMetadata.Contributor = usersMap[versionMetadata.CreatorId];
                        }
                    });
                });

                $scope.documentVersionsLoaded = true;

                if ($scope.documentState.documentVersions) {
                    $scope.documentState.totalVersionsSize = $scope.documentState.documentVersions.reduce(function(accumulator, version) {
                        return version.Size + accumulator;
                    }, 0);
                    $scope.documentState.documentVersions.forEach(function(versionMetadata){
                        var newFeedbackSection;
    
                        //When there's no entry inthe feedbackListMap for this VersionId we should add
                        //a empty overall feedbackSection object. Otherwise the overall feedback input field
                        //does not showup.
                        if (!$scope.documentState.feedbackListMap[versionMetadata.VersionId]) {
                            newFeedbackSection = [];
                            newFeedbackSection.title = AppConstants.DOC_LEVEL;
                            newFeedbackSection.marker = 0;
                            $scope.documentState.feedbackListMap[versionMetadata.VersionId] = [newFeedbackSection];
                            $scope.documentState.documentVersionCommentsMap[versionMetadata.VersionId] = 0;
                        }
                    });
                }

                $scope.documentVersionIdToVersionNumberMap = processDocumentVersionIdToVersionNumberMap($scope.documentState.documentVersions);
            });

            UserService.getUserById($scope.metadata.CreatorId).then(function(response) {
                $scope.metadata.Owner = response.data.User;
                $scope.documentState.currentOwnerUsername = $scope.metadata.Owner.Username;
            });


            if ($scope.metadata.CheckoutInfo) {
                if ($scope.metadata.CheckoutInfo.CheckoutUserId !== userInfo.Id) {
                    UserCollectionService.getUserCollection([$scope.metadata.CheckoutInfo.CheckoutUserId])
                        .then(function(Users) {
                            var User;
                            if (Users.length) {
                                User = Users[0];
                                //We need to translate the GivenName/Surname to Full Name conversion, because in different languages the Full Name conversion is done differently
                                $scope.metadata.CheckoutInfo.CheckoutUserName = $translate.instant('DOCUMENT_VIEW.VERSION.AUTHOR', {
                                    givenName : User.GivenName,
                                    surName : User.Surname
                                });
                            }
                        });
                }
                if ($scope.isDocumentCheckedOutByAnApp($scope.metadata) &&
                    !$scope.metadata.appUnlockStatus && !$scope.documentState.officeEditorMode) {
                    //If the WOPI Server has locked it then check for unlock signal
                    (function() {
                        var timeoutVal,
                            startTime = Date.now(),
                            currentBackoffVal = 1;

                        $scope.$on("$destroy", function() {
                            if (timeoutVal) {
                                $timeout.cancel(timeoutVal);
                            }
                        });

                        function rescheduleTheCall() {
                            //Only reschedule until a certain time. After that set a flag on the document that wopi unlock failed
                            if ((Date.now() - startTime) > (AppConstants.O365.MAX_TIME_LIMIT_IN_WAITING_FOR_UNLOCK_IN_SEC * 1000)) {
                                //Set a flag in the view model when the unlock is timedout
                                $scope.metadata.appUnlockStatus = AppConstants.APP_UNLOCK_STATUS.TIMEOUT;
                                return;
                            }
                            currentBackoffVal = Math.min(currentBackoffVal * 2, AppConstants.O365.MAX_TIME_LIMIT_IN_RETRYING_FOR_UNLOCK_IN_SEC);
                            timeoutVal = $timeout(checkForUnlockSignal, currentBackoffVal * 1000);
                            if (currentBackoffVal === 1) {
                                currentBackoffVal = 2;
                            }
                        }

                        function checkForUnlockSignal() {
                            timeoutVal = null;
                            //make getDocument call to determine if the unlock is done
                            DocumentService.getDocument($scope.metadata.Id, true)
                                .then(function getDocumentSuccessCallback(response) {
                                    var data = response.data;
                                    if (data && data.Metadata) {
                                        var Metadata = data.Metadata;
                                        if (!$scope.isDocumentCheckedOut(Metadata) || !$scope.isDocumentCheckedOutByAnApp(Metadata)) {
                                            $scope.metadata.CheckoutInfo = Metadata.CheckoutInfo;
                                            $scope.metadata.appUnlockStatus = AppConstants.APP_UNLOCK_STATUS.COMPLETE;
                                            $scope.getDocument();
                                        } else if ($scope.isDocumentCheckedOutByAnApp(Metadata)) {
                                            //If the document is still not unlocked and it contains a Reason field then retry the call
                                            rescheduleTheCall();
                                        }
                                    } else {
                                        rescheduleTheCall();
                                    }
                                }, rescheduleTheCall);

                        }
                        checkForUnlockSignal();
                        $scope.metadata.appUnlockStatus = AppConstants.APP_UNLOCK_STATUS.PENDING;
                    }());
                }
            }

            if (!$scope.layout.isAnonymous) {
                DocumentService.getDocumentPath($scope.metadata.Id)
                .success(function(response) {
                    if (response && response.Path && angular.isArray(response.Path.Components) && response.Path.Components.length > 0) {
                        var rootFolderId = response.Path.Components[0].Id;

                        if (rootFolderId === userInfo.RootFolderId) {
                            DocumentStateService.locationType = viewTypes.OWN_TYPE;
                        } else if (rootFolderId === userInfo.RecycleBinFolderId) {
                            DocumentStateService.locationType = viewTypes.RECYCLE_TYPE;
                        } else {
                            DocumentStateService.locationType = viewTypes.SHARED_TYPE;
                        }

                        SessionManager.setLastDocumentType(DocumentStateService.locationType);

                        PathManager.setPath(response.Path, userInfo);
                        $scope.path = response.Path.Components;
                        /*

                        SessionManager.updateHistory(response.Path.Components.map(function(component) {
                            return component.Id;
                        }));
                        */
                    }
                });

                // Retrieve V2 Permissions from API and update UI accordingly
                ResourceService.describeResourcePermissions($scope.metadata.Id, ['PRINCIPALS'])
                    .success(function(response) {
                        processShareLink(response);
                        processDocumentPermissions(response);
                        // Show the upload pane if:
                        // a) document is shared, in a shared folder or the user is the owner
                        // b) downloads / uploads are allowed by the owner.
                        $scope.layout.showUploadPane = $scope.showUploadButton() && $scope.showDownloadButton();
                        $scope.permissonsLoaded = true;

                        //https://hostname/workdocs/#/document/8aef0c26d0de65a51b91f10730e381824a46e26e65dffcca11059465c3d9cf67?RequestAccessUserId=S-1-5-21-2475184061-3893120877-1055375187-3623&d-90673160c4
                        if (!$scope.documentState.sharingDialogShownForRequestAccess && $scope.hasSharePermission() && $routeParams.RequestAccessUserId) {
                            $scope.documentState.sharingDialogShownForRequestAccess = true;
                            $scope.showCreateShareModal();
                        }
                        ClientMetricsService.recordPageVisible();
                    });

                // Retrieve the feedback request info from API
                ResourceService.getFeedbackRequests($scope.metadata.Id)
                    .success(function(response) {
                        processFeedbackRequests(response);
                    });

            } else {
                $scope.permissonsLoaded = true;
                DocumentStateService.userRights = ResourceService.processUserRightsFromRoles([globalRoles.VIEWER]);
                // Please note that the "Allow Downloads" option in File settings drives the "Download a copy" button for anonymous users.
                if ($scope.metadata.DocumentLevelPermissions && $scope.metadata.DocumentLevelPermissions.Download === AppConstants.Permissions.GRANTED) {
                    DocumentStateService.userRights.add(permissions.DOWNLOAD);
                }
                $scope.sidebar.tabs = [rightTabTypes.PEOPLE_TAB];
            }
        }

        $scope.prevDocEnabled = false;
        $scope.nextDocEnabled = false;
        $scope.imgPosition = null;

        /* This function does two things:
         * 1. get the image position info, get value for $scope.imgPosition
         * 2. determin whether the prev/next button should be shown
         */
        function updateImageNavInfo() {
            // If the feature is not enabled, no need to check
            if (!FeatureManagerService.isFeatureEnabled(Features.UI.IMAGE_NAV) ||
                !ContentTypeFormatter.isImageFile($scope.documentState.activeVersion.ContentType)) {
                return;
            }
            GetNextDocumentService.findCurrentImgPosition($scope.metadata.Id, $scope.metadata.ParentFolderId).then(function imgPositionFoundCallback(result) {
                var thereMayBeMore = GetNextDocumentService.getMarker($scope.metadata.ParentFolderId);

                // show prev button?
                $scope.prevDocEnabled = (result.position > 1);

                // show next button?
                $scope.nextDocEnabled = thereMayBeMore? true: (result.position < result.count);

                // get value for showing image position
                $scope.imgPosition = result.position + '/' + result.count;
                if (thereMayBeMore) {
                    $scope.imgPosition += '+';
                }
            }, function imgPositionNotFoundCallback(err) {
                $scope.imgPosition = null;
                ClientMetricsService.addLogsToSession({
                    event: "DOCUMENT_IMAGE_GET_POSITION_ERROR",
                    metadata: ('error message: ' + err),
                    documentId : $scope.documentState.documentId,
                });
            });
        }

        $scope.nextImg = function(docId, parentFolderId) {
            docId = docId || $scope.metadata.Id;
            parentFolderId = parentFolderId || $scope.metadata.ParentFolderId;

            GetNextDocumentService.getNextImg(docId, parentFolderId)
            .then(function success(nextDoc) {
                $rootScope.goto('/document/' + nextDoc.Id);
            }, function error(err) {
                if (err === 'DOCUMENT_NAV.LAST_DOC') {
                    MessageManager.addInfoMessage($translate.instant('DOCUMENT_NAV.LAST_DOC'));
                    updateImageNavInfo();
                }
            });
        };

        $scope.prevImg = function(docId, parentFolderId) {
            docId = docId || $scope.metadata.Id;
            parentFolderId = parentFolderId || $scope.metadata.ParentFolderId;

            GetNextDocumentService.getPreviousImg(docId, parentFolderId)
            .then(function success(nextDoc) {
                $rootScope.goto('/document/' + nextDoc.Id);
            }, function error(err) {
                if (err === 'DOCUMENT_NAV.NO_PREVIOUS') {
                    MessageManager.addInfoMessage($translate.instant('DOCUMENT_NAV.NO_PREVIOUS'));
                    updateImageNavInfo();
                }
            });
        };

        // This function is not used. keep it in case of adding back the removed functionality
        // $scope.sharedLinkScope2ShortDescription = function(sharedLinkScope) {
        //     switch(sharedLinkScope) {
        //         case null:
        //             return $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_NO_LINK');
        //         case AppConstants.SharedLinkScope.ANONYMOUS:
        //             return $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_ANYONE');
        //         case AppConstants.SharedLinkScope.SITE_VIEWER:
        //             return $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_SITE_VIEWER');
        //         case AppConstants.SharedLinkScope.SITE_CONTRIBUTOR:
        //             return $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_SITE_CONTRIBUTOR');
        //         default:
        //             return null;
        //     }
        // };

        // $scope.copySharedLinkToClipBoard = function() {
        //     var copySuccess = Utils.copyTextToClipboard(document, $scope.documentState.SharedLinkUrl);
        //     if (!copySuccess) {
        //         MessageManager.addErrorMessage($translate.instant('MESSAGES.LINK_COPY_CLIPBOARD'));
        //     }
        // };

        // Processing the feedback requests (only has Deadine for now)
        function processFeedbackRequests(data) {
            var feedbackRequestInfo = {};
            angular.forEach(data.FeedbackRequests, function(request) {
                feedbackRequestInfo[request.PrincipalId] = {
                    Deadline: request.Deadline
                };
            });

            $scope.documentState.feedbackRequestInfo = feedbackRequestInfo;
        }

        // deprecated functionality. keep it for a while in case of adding it back.
        // function getSharedLinkUrlForFile (sharedLinkScope, shareResourceId) {
        //     var tempElement = $document[0].createElement('a');
        //     switch(sharedLinkScope) {
        //         case AppConstants.SharedLinkScope.ANONYMOUS:
        //             tempElement.href = '#/share/document/' + encodeURIComponent(shareResourceId);
        //             return tempElement.href;
        //         case AppConstants.SharedLinkScope.SITE_VIEWER:
        //         case AppConstants.SharedLinkScope.SITE_CONTRIBUTOR:
        //             tempElement.href = '#/document/' + encodeURIComponent(shareResourceId);
        //             return tempElement.href;
        //         default:
        //             return null;
        //     }
        // }

        // deprecated functionality. keep it for a while in case of adding it back.
        // function setSharedLinkScopeForFile(resourcePermissionsResponse) {
        //     $scope.documentState.sharedLinkScope = null;
        //     $scope.documentState.SharedLinkUrl = getSharedLinkUrlForFile($scope.documentState.sharedLinkScope, $scope.metadata.Id);
        //     resourcePermissionsResponse.Principals.forEach(function(principal) {
        //         if (principal.Type === 'ANONYMOUS') {
        //             $scope.documentState.sharedLinkScope = AppConstants.SharedLinkScope.ANONYMOUS;
        //             $scope.documentState.SharedLinkUrl = getSharedLinkUrlForFile($scope.documentState.sharedLinkScope, $scope.metadata.Id);
        //         }
        //         if (principal.Type === 'ORGANIZATION' && principal.Roles[0].Type === 'DIRECT') {
        //             switch(principal.Roles[0].Role) {
        //                 case 'VIEWER':
        //                     $scope.documentState.sharedLinkScope = AppConstants.SharedLinkScope.SITE_VIEWER;
        //                     $scope.documentState.SharedLinkUrl = getSharedLinkUrlForFile($scope.documentState.sharedLinkScope, $scope.metadata.Id);
        //                     break;
        //                 case 'CONTRIBUTOR':
        //                     $scope.documentState.sharedLinkScope = AppConstants.SharedLinkScope.SITE_CONTRIBUTOR;
        //                     $scope.documentState.SharedLinkUrl = getSharedLinkUrlForFile($scope.documentState.sharedLinkScope, $scope.metadata.Id);
        //                     break;
        //                 default:
        //                     break;
        //             }
        //         }
        //     });
        // }

        $scope.showManageLink = function() {
            return $scope.hasShareLink && $scope.permissonsLoaded && DocumentStateService.locationType !== viewTypes.RECYCLE_TYPE;
        };

        $scope.copyShareLink = function() {
            ShareLinkService.copyLinkToClipboard($scope.shareLink);
        };

        function processShareLink(resourcePermissionsResponse) {
            var sharedLinkScope = ShareLinkService.getSharedLinkScope(resourcePermissionsResponse.Principals);
            $scope.hasShareLink = !!sharedLinkScope;
            $scope.manageLinkDetail = ShareLinkService.getLinkPermissionsDetail(sharedLinkScope);
            $scope.shareLink = ShareLinkService.getShareLink(sharedLinkScope, $scope.metadata.Id, AppConstants.ResourceTypes.FILE);
        }


        // Processing the document permissions
        function processDocumentPermissions(resourcePermissionsResponse) {
            var resourcePermissions = ResourceService.processResourcePermissionResponse(resourcePermissionsResponse, userInfo, $scope.layout.isAnonymous);

            // Set the documentState variables for permissionsV2
            $scope.documentState.principals = resourcePermissions.principals;
            $scope.documentState.principals.all = $scope.documentState.principals.direct.concat($scope.documentState.principals.inherited);
            DocumentStateService.currentUserRoles = resourcePermissions.currentUserRoles;
            // Determines what rights are given to the current user based on their roles.
            DocumentStateService.userRights = ResourceService.processUserRightsFromRoles(resourcePermissions.currentUserRoles);

            // Add user principals to feedback map (for annotation coloring)
            addUserPrincipalsToFeedbackMap($scope.documentState.principals.all);

            if (!resourcePermissionsResponse.Attributes.DOWNLOAD || resourcePermissionsResponse.Attributes.DOWNLOAD === ALLOWED) {
                DocumentStateService.userRights.add(permissions.DOWNLOAD);
            }

            $scope.documentState.disallowDownload = resourcePermissionsResponse.Attributes.DOWNLOAD === DISALLOWED;

            // Update tabs based on permission
            if (hasRightForDocument(permissions.CONTRIBUTE) && !$scope.inRecycleBin()) {
                $scope.sidebar.tabs = rightTabTypes.CONTRIBUTOR_TABS;
            } else {
                $scope.sidebar.tabs = rightTabTypes.VIEWER_TABS;
            }

            // set the shared link scope (deprecated functionality. keep it for a while in case of adding it back)
            // setSharedLinkScopeForFile(resourcePermissionsResponse);
        }

        function addUserPrincipalsToFeedbackMap(principals) {

            // Add the direct users based on the order they would be on the People Tab
            var userPrincipals = _.sortBy(_.filter(principals, { Type: collaboratorTypes.USER }), $scope.getPermissionLevel);
            userPrincipals.reverse();

            angular.forEach(userPrincipals, function(user) {
                $scope.addUserToFeedbackUserMap(user);
            });
        }

        function switchToFeedback(personEntry) {
            if (!$scope.documentState.userToFeedbackCountMap[personEntry.Id]) {
                return;
            }
            //When filtering by user due to click on People panel picture, show all kinds of feedback
            $scope.documentState.commentFilterPreferenceMap.user = personEntry.Id;
            $scope.documentState.commentFilterPreferenceMap.published = true;
            $scope.documentState.commentFilterPreferenceMap.drafts = true;
            $scope.documentState.commentFilterPreferenceMap.unresolved = true;
            $scope.documentState.commentFilterPreferenceMap.resolved = true;

            $scope.applyFeedbackFilters();
            DocumentStateService.hasFilter = true;
            $scope.$broadcast(SignalProvider.Feedback.SwitchUser);
            $scope.showRightTabSliding(rightTabTypes.FEEDBACK_TAB);
        }

        // This function gets called when a user expands users in a group
        function switchToGroup(groupEntry) {

            $scope.groupInfo.selectedGroup = groupEntry;
            $scope.groupInfo.groupName = groupEntry.Name;

            switch (groupEntry.Role) {
                case globalRoles.VIEWER:
                    $scope.groupInfo.role = $translate.instant('RIGHT_NAV.VIEWER');
                    break;
                case globalRoles.CONTRIBUTOR:
                    $scope.groupInfo.role = $translate.instant('RIGHT_NAV.CONTRIBUTOR');
                    break;
                case globalRoles.COOWNER:
                    $scope.groupInfo.role = $translate.instant('RIGHT_NAV.CO_OWNER');
                    break;
            }

            // Populate the usersInGroup array, then append NUM_GROUP_USERS_SHOWN (8 by default) users to the view.
            getUsersInGroup(groupEntry).then(function() {
                appendMoreUsers();
            }, function(error) {
                $scope.groupInfo.errorText = MessageProvider.requestEntityTooLargeMessage;
                $scope.groupInfo.hideShowMore = true;
            });

            $timeout(function() {
                $scope.groupInfo.expandGroupShown = true;
            }, 500);
        }

        // Makes the API call to populate the usersInGroup array.
        // This returns a promise so #switchToGroup can make the call to #appendMoreUsers on success.
        function getUsersInGroup(groupEntry) {
            var deferred = $q.defer();

            GroupService.getUsersInGroup(groupEntry.Id, groupEntry.Vendor, ['PRINCIPALS'], groupUserMarker)
            .then(function(res) {
                if (res && res.Users) {
                    // Populate usersInGroup with the results.
                    angular.forEach(res.Users, function(value) {
                        usersInGroup.push(value);
                    });
                    groupUserMarker = res.Marker;
                    deferred.resolve();
                } else {
                    // If service returns no results, then hide the "Show More" button.
                    $scope.groupInfo.hideShowMore = true;
                    deferred.resolve();
                }

            }).catch(function(error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        // Grabs NUM_GROUP_USERS_SHOWN users from the usersInGroup array and appends it to the groupMembers array.
        function appendMoreUsers() {
            var moreUsers = usersInGroup.splice(0, NUM_GROUP_USERS_SHOWN);

            // If there are less than NUM_GROUP_USERS_SHOWN users left, or
            // if we already fetch the last page of group members and there are no users leftover
            // then hide the "load More" button.
            if (moreUsers.length < NUM_GROUP_USERS_SHOWN || (usersInGroup.length === 0 && !groupUserMarker)) {
                $scope.groupInfo.hideShowMore = true;
            }

            // Concat moreUsers to the array of users shown in the people tab
            $scope.groupInfo.groupMembers = $scope.groupInfo.groupMembers.concat(moreUsers);
        }
    }
}(angular, _));
